import styled from "styled-components";

export const TitleH1 = styled.h1`
  text-align: center;
  font-size: 54px;
  font-weight: 600;
  position: relative;
`;

export const QrCodeImage = styled.img`
  width: 230px;
  height: 230px;
`;

export const SpanDescription = styled.strong`
  font-size: 22px;
  font-weight: 300;
`;

export const SpanSubtitle = styled.strong`
  font-size: 30px;
  font-weight: 600;
`;
